import React from 'react';
import { SearchActionMenuContextType } from './types';

const SearchActionMenuContext = React.createContext<
  SearchActionMenuContextType | undefined
>(undefined);

export default SearchActionMenuContext;
